import BaseModel from '../base';

export default class Criterian extends BaseModel {
  constructor(criterian, url) {
    super(criterian, url);

    this.name = criterian.name;
    this.max_score = criterian.max_score;
    this.description = criterian.description;
    this.min_score = criterian.min_score || 0;
    this.event_poll_questions_id = criterian.event_poll_questions_id;
    this.owner_id = criterian.owner_id;
  }

  get putFormat() {
    const {
      name,
      min_score,
      max_score,
      description,
    } = this;

    return {
      name,
      min_score,
      max_score,
      description,
    };
  }
}
